// Data layer for the published-setlist view. One cookie-authed GET /api/setlists/:id.

export interface SetlistMeta {
  setlistId: string; teamId: string; ownerUserId: string; name: string; createdAt: string; updatedAt: string;
  // Единый сетлист, фаза 2 — воркер шлёт эти поля аддитивно; старый воркер их
  // не шлёт, поэтому все необязательные.
  wordsPublic?: boolean;
  audioPublic?: boolean;
  hasGuestKey?: boolean;
  /** id живой ссылки слов для лайва, или null. Старый путь — summary?.textShareId. */
  liveId?: string | null;
  // Единый сетлист, фаза 3 — гостевой экран показывает дату/команду.
  eventDate?: string | null;
  teamName?: string | null;
}
export interface SetlistItem { position: number; shareId: string; songId: string | null; songName: string | null; }
/**
 * Песня сетлиста (единый сетлист, фаза 2): слова и все версии — как их видит
 * вызывающий (доступ уже применён сервером). `versions[0]` — новейшая.
 */
export interface SetlistSong {
  position: number;
  songId: string | null;
  songName: string | null;
  words: { id: string; name: string; key: string | null } | null;
  versions: Array<{ shareId: string; sessionId: string | null; label: string | null; recordedAt: string | null; createdAt: string }>;
}
export type SetlistResult =
  | {
      ok: true; setlist: SetlistMeta; items: SetlistItem[];
      // Единый сетлист, фаза 2 — необязательные, старый воркер их не шлёт.
      songs?: SetlistSong[];
      access?: { words: boolean; audio: boolean; member: boolean };
    }
  | { ok: false; needsAuth?: boolean; notFound?: boolean };

export async function fetchPublishedSetlist(
  setlistId: string,
  apiBase = '',
  fetchImpl: typeof fetch = fetch,
  opts?: { guestKey?: string | null },
): Promise<SetlistResult> {
  try {
    // Кука всегда идёт (`credentials: 'include'`) — участник команды получает
    // member-доступ на воркере раньше, чем тот посмотрит на гостевую ветку.
    // `g` — только для анонимного гостя по ссылке с ключом.
    const guestKey = opts?.guestKey;
    const url = guestKey
      ? `${apiBase}/api/setlists/${encodeURIComponent(setlistId)}?g=${encodeURIComponent(guestKey)}`
      : `${apiBase}/api/setlists/${encodeURIComponent(setlistId)}`;
    const res = await fetchImpl(url, { credentials: 'include' });
    if (res.status === 401) return { ok: false, needsAuth: true };
    if (res.status === 404) return { ok: false, notFound: true };
    if (!res.ok) return { ok: false };
    const body = await res.json() as any;
    return {
      ok: true,
      setlist: body.setlist,
      items: Array.isArray(body.items) ? body.items : [],
      songs: Array.isArray(body.songs) ? body.songs : undefined,
      access: body.access,
    };
  } catch {
    return { ok: false };
  }
}
